import { html, TemplateResult } from "lit-html";
import { ifDefined } from "lit-html/directives/if-defined"

const LabelComponent = ({
  labelFor,
  cssClasses,
  labelText = ''
}: ILabelElement): TemplateResult => {
  return html`
    <label
      for=${ifDefined(labelFor)}
      class=${ifDefined(cssClasses)}
    >
    ${labelText}
    </label>
  `;
}

export default LabelComponent;